<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.cellar_id" class="modal-card-title">Crear Bodega</p>
          <p v-else class="modal-card-title">Editar Bodega</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="cellar.name"
              v-model="cellar.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <b-field label="Establecimiento">
            <b-select placeholder="Seleccionar Establecimiento" v-model="cellar.stablishment_id" expanded>
              <option
                v-for="stablishment in listStablishment"
                :value="stablishment.id"
                :key="stablishment.id"
              >{{ stablishment.name }}</option>
            </b-select>
          </b-field>                 
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.cellar_id" class="button is-primary" @click="createCellar()">Guardar</button>
          <button v-else class="button is-primary" @click="editCellar()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import {CellarService} from "./../../../services/models/cellar";
import {StablishmentService} from "./../../../services/models/stablishment";
export default {
  props: ["isComponentModalActive", "closeBasic", "chargeListCellars", "cellar_id"],
  data() {
    return {
      cellar: {
        name: "",
        stablishment_id: "",
        address:""
      },
      listStablishment: [],
      isLoading:false
    };
  },
  async created () {
    this.isLoading=true;
    await this.chargeLists();
    if (this.cellar_id) {
      const {data} = await CellarService.getById(this.cellar_id);
      this.cellar = data;
    }
    this.isLoading = false;
  },
  methods: {
    async createCellar () {
      this.isLoading = true;
      try {
        await CellarService.create(this.cellar);
        this.chargeListCellars();
        this.closeBasic();
        this.toast("Creado la bodega", "is-success");
      } catch (err) {
        this.toast("Error al crear", "is-danger");
      }
      this.isLoading = false;
    },
    async editCellar () {
      this.isLoading = true;
      try {
        await CellarService.update( this.cellar_id,this.cellar);
        this.chargeListCellars();
        this.closeBasic();
        this.toast("Editado la bodega", "is-success");
      } catch (error) {
        this.toast("Error al editar", "is-danger");
      }
      this.isLoading = false;
    },
    async chargeLists () {
      const {data} = await StablishmentService.getAll()
      this.listStablishment = data.data;
    }
  }
};
</script>